import Vue from 'vue';
import App from './App.vue';

import Vuex from 'vuex'
import ElementUI from 'element-ui';
import 'iview/dist/styles/iview.css';
import './theme/index.css';
import router from './router/index';
import axios from 'axios';
import NProgress from 'nprogress';
import './static/css/style.css';
Vue.config.productionTip = false;
import FoxRequest from './utils/request';
Vue.use( Vuex );
Vue.use(ElementUI);
import { Spin } from 'iview';
Vue.component('Spin', Spin);
import { Page } from 'iview';//图片弹窗插件引用
Vue.component('Page', Page);//图片弹窗插件引用
Vue.prototype.$Spin = Spin;
axios.defaults.withCredentials = true;
Vue.prototype.$axios = axios;
Vue.prototype.FoxRequest = FoxRequest;
//获取字符串长度||中文算2个
Vue.prototype.getByteLen = function(val) {
    let len = 0;
    for (var i = 0; i < val.length; i++) {
        var a = val.charAt(i);
        if (a.match(/[^\x00-\xff]/ig) != null)
        {
            len += 2;
        }
        else
        {
            len += 1;
        }
    }
    return len;
}
import VueCookies from 'vue-cookies';
Vue.prototype.$cookies = VueCookies;
import ImageDialog from './utils/ChooseImage';
Vue.prototype.$imageDialog = ImageDialog.install;
const store = new Vuex.Store({
    state:{
        account: '',
        message_count: 0
    }
});


router.beforeEach((to, from, next) => {
    NProgress.start()
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    const type = to.meta.type
    // 判断该路由是否需要登录权限
    if (type === 'login' || type === 'loginJump') {
        FoxRequest(window.settings.api_url + 'index/account/login', {}, function (response) {
            var data = response.data;
            if (data.error != 0){
                Vue.prototype.$message({
                    message: data.result.message,
                    type: "error"
                });
                return;
            }
            store.state.account = data.result.account;
            store.state.message_count = data.result.message_count;
            if(type === 'login'){
                if(data.result.account == ''){

                    next('/account/login')
                }else{

                    next()
                }
            }else {
                if(data.result.account == ''){
                    next()
                }else{
                    if (data.result['is_main'] == '1') {
                        window.location.href = "/manage";
                    } else {
                        window.location.href = "/warehouse";
                    }
                    //next('/account/router')
                }
            }
        }, false, true);
    } else {
        next()
    }
});

router.afterEach(() => {
    NProgress.done()
});

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
